import type {RouteRecordRaw} from 'vue-router'

import Disclaimer from "@/pages/agreements/Disclaimer.vue"
import UserAgreement from "@/pages/agreements/UserAgreement.vue"
import PrivacyPolicy from "@/pages/agreements/PrivacyPolicy.vue"
import LegalDisclaimer from "@/pages/agreements/LegalDisclaimer.vue"
import TermsOfService from "@/pages/agreements/TermsOfService.vue"
import CookiesPolicy from "@/pages/agreements/CookiesPolicy.vue"

export default <RouteRecordRaw[]>[
  {
    name: 'agreement-disclaimer', path: '/agreements/disclaimer',
    component: Disclaimer,
  },
  {
    name: 'agreement-useragreement', path: '/agreements/useragreement',
    component: UserAgreement,
  },
  {
    name: 'agreement-privacypolicy', path: '/agreements/privacypolicy',
    component: PrivacyPolicy,
  },
  {
    name: 'agreement-legaldisclaimer', path: '/agreements/legaldisclaimer',
    component: LegalDisclaimer,
  },
  {
    name: 'agreement-cookiespolicy', path: '/agreements/cookiespolicy',
    component: CookiesPolicy,
  },
  {
    name: 'agreement-termsofservice', path: '/agreements/termsofservice',
    component: TermsOfService,
  },
]
